import {
    GET_DAILY_REPORT_DATA,
    GET_DAILY_REPORT_DATA_FAILURE,
    GET_DAILY_REPORT_DATA_SUCCESS,
    UPDATE_REPORT_NOTES,
    UPDATE_REPORT_NOTES_FAILURE,
    UPDATE_REPORT_NOTES_SUCCESS,
    EXPORT_DOC,
    EXPORT_DOC_FAILURE,
    EXPORT_DOC_SUCCESS,
    GET_ALL_REPORTS_DATA,
    GET_ALL_REPORTS_DATA_SUCCESS,
    GET_ALL_REPORTS_DATA_FAILURE,
} from './constants';

export function getDailyReportData (page, filterOptions, sortingOptions) {
    return {
        type: GET_DAILY_REPORT_DATA,
        data: { page, filterOptions, sortingOptions }
    }
}

export function getDailyReportDataSuccess (responseData) {
    return {
        type: GET_DAILY_REPORT_DATA_SUCCESS,
        data: responseData
    }
}

export function getDailyReportDataFailure () {
    return {
        type: GET_DAILY_REPORT_DATA_FAILURE,
        data: {}
    }
}

export function getAllDailyReportData (page, filterOptions, sortingOptions,getAllReports) {
    return {
        type: GET_ALL_REPORTS_DATA,
        data: { page, filterOptions, sortingOptions,getAllReports }
    }
}

export function getAllDailyReportDataSuccess (responseData) {
    return {
        type: GET_ALL_REPORTS_DATA_SUCCESS,
        data: responseData
    }
}

export function getAllDailyReportDataFailure () {
    return {
        type: GET_ALL_REPORTS_DATA_FAILURE,
        data: {}
    }
}


export function updateReportNotes (bookingId, reportNote) {
    return {
        type: UPDATE_REPORT_NOTES,
        data: {bookingId, reportNote}
    }
}

export function updateReportNotesSuccess (response) {
    return {
        type: UPDATE_REPORT_NOTES_SUCCESS,
        data: response.data
    }
}

export function updateReportNotesFailure () {
    return {
        type: UPDATE_REPORT_NOTES_FAILURE,
        data: {}
    }
}

export function exportDoc (type, filterOptions) {
    return {
        type: EXPORT_DOC,
        data: {type, filterOptions}
    }
}

export function exportDocSuccess (response) {
    return {
        type: EXPORT_DOC_SUCCESS,
        data: response.data
    }
}

export function exportDocFailure () {
    return {
        type: EXPORT_DOC_FAILURE,
        data: {}
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DailyReport/actions.js